import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>{t('privacyPolicy.title')}</h1>
      <p><strong>{t('privacyPolicy.effectiveDate')}</strong></p>

      <h2>{t('privacyPolicy.introduction.title')}</h2>
      <p>{t('privacyPolicy.introduction.p1')}</p>
      <p>{t('privacyPolicy.introduction.p2')}</p>

      <h2>{t('privacyPolicy.informationWeCollect.title')}</h2>
      <p>{t('privacyPolicy.informationWeCollect.p1')}</p>
      <h3>{t('privacyPolicy.informationWeCollect.h3_1')}</h3>
      <p><strong>{t('privacyPolicy.informationWeCollect.p2_strong')}</strong>{t('privacyPolicy.informationWeCollect.p2')}</p>
      <p><strong>{t('privacyPolicy.informationWeCollect.p3_strong')}</strong>{t('privacyPolicy.informationWeCollect.p3')}</p>
      <h3>{t('privacyPolicy.informationWeCollect.h3_2')}</h3>
      <p><strong>{t('privacyPolicy.informationWeCollect.p4_strong')}</strong>{t('privacyPolicy.informationWeCollect.p4')}</p>
      <p><strong>{t('privacyPolicy.informationWeCollect.p5_strong')}</strong>{t('privacyPolicy.informationWeCollect.p5')}</p>

      <h2>{t('privacyPolicy.howWeUseYourInformation.title')}</h2>
      <p>{t('privacyPolicy.howWeUseYourInformation.p1')}</p>
      <ul>
        <li>{t('privacyPolicy.howWeUseYourInformation.li1')}</li>
        <li>{t('privacyPolicy.howWeUseYourInformation.li2')}</li>
        <li>{t('privacyPolicy.howWeUseYourInformation.li3')}</li>
        <li>{t('privacyPolicy.howWeUseYourInformation.li4')}</li>
      </ul>
      <p>{t('privacyPolicy.howWeUseYourInformation.p2')}</p>

      <h2>{t('privacyPolicy.howWeShareYourInformation.title')}</h2>
      <p>{t('privacyPolicy.howWeShareYourInformation.p1')}</p>
      <ul>
        <li>{t('privacyPolicy.howWeShareYourInformation.li1')}</li>
        <li>{t('privacyPolicy.howWeShareYourInformation.li2')}</li>
      </ul>

      <h2>{t('privacyPolicy.dataRetentionAndDeletion.title')}</h2>
      <p>{t('privacyPolicy.dataRetentionAndDeletion.p1')}</p>
      <p><strong>{t('privacyPolicy.dataRetentionAndDeletion.p2_strong')}</strong>{t('privacyPolicy.dataRetentionAndDeletion.p2')}</p>
      <p><strong>{t('privacyPolicy.dataRetentionAndDeletion.p3_strong')}</strong>{t('privacyPolicy.dataRetentionAndDeletion.p3')}</p>

      <h2>{t('privacyPolicy.dataSecurity.title')}</h2>
      <p>{t('privacyPolicy.dataSecurity.p1')}</p>

      <h2>{t('privacyPolicy.yourPrivacyRights.title')}</h2>
      <p>{t('privacyPolicy.yourPrivacyRights.p1')}</p>

      <h2>{t('privacyPolicy.childrensPrivacy.title')}</h2>
      <p>{t('privacyPolicy.childrensPrivacy.p1')}</p>

      <h2>{t('privacyPolicy.changesToThisPrivacyPolicy.title')}</h2>
      <p>{t('privacyPolicy.changesToThisPrivacyPolicy.p1')}</p>

      <h2>{t('privacyPolicy.contactUs.title')}</h2>
      <p>{t('privacyPolicy.contactUs.p1')}<br />
      https://globalpdftools.com/contact</p>
      <p>
        Kevos Technologies LLC<br />
        1209 MOUNTAIN ROAD PL NE, STE R<br />
        ALBUQUERQUE, NM 87110
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;